<template>
	<div>
		<!-- Select template -->
		<j-base-multi-select-with-flexible-value
			v-model="selectedTemplate"
			:options="templates"
			:allowMultiselect="false"
			:allowLocalSearch="true"
			placeholder="Search template..."
		/>

		<!-- Variables -->
		<div class="mt4">
			<!-- Type selection -->
			<div class="flex xs-right">
				<j-button
					size="xsmall"
					:type="type === 'variables' ? 'secondary' : 'bordered'"
					@click="type = 'variables'"
					>{{ $t("graphql_variables") }}</j-button
				>
				<j-button
					class="mr1"
					size="xsmall"
					:type="type === 'content' ? 'secondary' : 'bordered'"
					@click="type = 'content'"
					>{{ $t("json_object") }}</j-button
				>
			</div>

			<!-- ContentJson -->
			<div v-show="type === 'content'">
				<p class="fs4 fw7 c1 mb1">{{ $t("json_object") }}</p>
				<core-monaco-editor
					language="json"
					v-model="contentJson"
					:options="editorOptions"
				/>
			</div>

			<!-- VariablesJson -->
			<div v-show="type === 'variables'">
				<p class="fs4 fw7 c1 mb1">{{ $t("graphql_variables") }}</p>
				<core-monaco-editor
					language="json"
					v-model="variablesJson"
					:options="editorOptions"
				/>
			</div>
		</div>

		<div class="mt4">
			<j-button
				v-if="selectedTemplate"
				:isLoading="isLoading"
				@click="downloadPdf"
				>Download PDF</j-button
			>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton, CoreMonacoEditor, JBaseMultiSelectWithFlexibleValue },

	props: {
		caseId: String
	},

	data() {
		return {
			isLoading: false,

			// Templates
			templates: [],
			selectedTemplate: null,

			// Variables values
			type: "variables", // or content
			variablesJson: JSON.stringify({
				caseWhere1: { id: this.$store.state.caseManagement.caseId },
				proposalWhere1: { id: this.$store.state.caseManagement.proposalId },
				offerWhere1: { id: this.$store.state.caseManagement.offerId }
			}),
			contentJson: "",

			// Monaco editor options
			editorOptions: {
				autoIndent: true,
				automaticLayout: true,
				autoClosingBrackets: true,
				formatOnPaste: true,
				formatOnType: true,
				tabCompletion: true
			}
		}
	},

	methods: {
		async fetchTemplates(value = "") {
			const query = gql`
				query fetchTemplates($where: templateWhereInput!, $sort: sortInput) {
					templates(where: $where, sort: $sort) {
						totalCount
						list {
							id
							name
							createdAt
							lastModifiedAt
							__typename
						}
					}
				}
			`

			let variables = {
				where: {},
				sort: { fieldName: "createdAt", type: "desc" }
			}
			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			this.templates = res?.data?.templates?.list
				?.filter(
					item =>
						item?.__typename === "pdfDrawingTemplate" ||
						item?.__typename === "wkhtmltopdfTemplate"
				)
				?.map(item => ({
					name: item.name,
					value: item.id,
					typename: item.__typename
				}))
		},

		async downloadPdf() {
			// Decide if it is PDF file or HTML PDF
			const templateType = this.selectedTemplate?.[0]?.typename
			let apiKey = "renderPdfDrawingTemplate"
			if (templateType === "wkhtmltopdfTemplate")
				apiKey = "renderWkhtmltopdfTemplate"

			// Query
			const query = `
				query ${apiKey}($templateId: String!, $input: templateRenderParametersInput){
					${apiKey}(templateId: $templateId input: $input) {
						errors
						status
						value
					}
				}
			`

			// Variables
			const variables = {
				templateId: this.selectedTemplate?.[0]?.value,
				input: { name: "data" }
			}

			// Based on if valuesJson or content Json was selected, send proper data
			if (this.type === "variables")
				variables.input.variablesJsonString = this.variablesJson
			else if (this.type === "content")
				variables.input.contentJsonString = this.contentJson

			// Call
			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			if (res.data?.[apiKey]?.errors && res.data?.[apiKey]?.errors?.length) {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: res?.errors?.toString() || res.data?.[apiKey]?.errors
					}
				})
			}

			if (res.data?.[apiKey]?.status === "success") {
				let bytes = new Uint8Array(res.data?.[apiKey]?.value) // pass your byte response to this constructor
				let blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
				let link = document.createElement("a")
				link.href = window.URL.createObjectURL(blob)
				link.download = "test.pdf"
				link.click()
			}
		}
	},

	mounted() {
		this.fetchTemplates()
	}
}
</script>
